const calcField = document.querySelector('input[name="calculator"]');
const qtyField = document.querySelector('input[name="qty"]');
const finalQtyField = document.querySelector('input[name="quantity"]');
const perPackage = document.querySelector('#perPackage');

const perPackageVal = perPackage.getAttribute('data-per-package');


const calcButtons = document.querySelectorAll('#calc-fields .quantity-selector__button');
const qtyButtons = document.querySelectorAll('#qty-fields .quantity-selector__button');

const finalQty = document.querySelector('#finalQty')



const addEventListeners = () =>{
    calcField.addEventListener('change',(e)=>{
        calculateQTY();
        calculateTemaxia(e);
    })

    qtyField.addEventListener('change',(e)=>{
        calculateM2()
    })

    for(const button of calcButtons){
        button.addEventListener('click',()=>{
            calculateQTY();
            // calculateM2();
        })
    }

    for(const button of qtyButtons){
        button.addEventListener('click',()=>{
            // calculateQTY();
            calculateM2();
        })
    }
}

const calculateM2 = () =>{
    const qtyValue = qtyField.value;

    const calculation = qtyValue * perPackageVal

    calcField.value =Math.floor(calculation);
    updateFinalQty();


}

const calculateQTY = () =>{
    const calcValue = calcField.value;

    qtyField.value = Math.ceil(calcValue / perPackageVal);
    updateFinalQty();

    // calcField.value =Math.floor( qtyValue * perPackageVal);
}
const updateFinalQty =()=>{
    const calcValue = qtyField.value * perPackageVal;
    finalQty.innerText = `Total: ${calcValue.toFixed(2)} M2`;

    finalQtyField.value = Math.ceil(calcValue);


}

function calculateTemaxia(e) {
    if (e.target.value <= 0) {
        qtyField.value = 0
    } else {
        qtyField.value = Math.ceil(parseFloat(e.target.value) / parseFloat(perPackageVal))
    }

    // document.querySelector("#packages").innerText = document.querySelector('#product-quantity').value
    // console.log(document.querySelector('#product-quantity').value)
    // document.querySelector("#packages_tm").innerText = (parseFloat(document.querySelector('#product-quantity').value) * parseFloat(document.querySelector("#srg_temaxio").innerText)).toFixed(2)
}

addEventListeners();